










































































































































































import Vue from "vue";
import axios, { AxiosPromise } from "axios";
import Multiselect from "vue-multiselect";
import get from "lodash-es/get";
import debounce from "lodash-es/debounce";
import isEmpty from "lodash-es/isEmpty";
import find from "lodash-es/find";
import map from "lodash-es/map";
import orderBy from "lodash-es/orderBy";
import groupBy from "lodash-es/groupBy";
import moment from "moment";
import DateRangePicker from "../../components/DateRangePicker.vue";
import { VestigingViewModel } from "./DashboardFilters.vue";
// import TestLeadData from "./TestLeadData";
// const testData = TestLeadData;

import {
  AutobedrijfViewModel,
  DropdownItemStringViewModel,
  DropdownItemModel,
  FixedPeriodType,
  FilterValuesPeriod,
} from "../../TypeScriptModels";

interface PivotLeadOptionViewModel {
  Perioden: DropdownItemModel[];
  Zones: DropdownItemModel[];
  Autobedrijven: AutobedrijfViewModel[];
  Vestigingen: VestigingViewModel[];
  LeadTypes: DropdownItemModel[];
  SoortenLead: DropdownItemModel[];
  Autosoorten: DropdownItemModel[];
  Merken: DropdownItemStringViewModel[];
}

interface PivotLeadSettingsViewModel {
  CustomStartDate: string | null;
  CustomEndDate: string | null;
  ComparePeriodData: boolean | null;
  CustomStartDateCompare: string | null;
  CustomEndDateCompare: string | null;
  SelectedPeriod: FixedPeriodType;
  SelectedZones: number[];
  SelectedAutobedrijven: string[];
  SelectedVestigingen: string[];
  SelectedLeadTypes: string[];
  SelectedLeadsoorten: string[];
  SelectedAutosoorten: string[];
  SelectedMerken: string[];
}

export interface FilterPivotLeadValues {
  period: FilterValuesPeriod | null;
  zonesValue: any[];
  autobedrijvenValue: any[];
  vestigingenValue: any[];
  leadTypesValue: any[];
  soortenLeadValue: any[];
  autosoortenValue: any[];
  merkenValue: any[];
  periodFromDate: Date;
  periodToDate: Date;
  customFromDate: Date;
  customToDate: Date;
  comparePeriodData: boolean;
  customFromDateCompare: Date;
  customToDateCompare: Date;
}

export default Vue.extend({
  components: {
    Multiselect,
    DateRangePicker,
  },

  props: {
    selectedOptions: {
      required: true,
      type: Object as () => FilterPivotLeadValues,
      default: {
        period: {} as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        leadTypesValue: [] as any[],
        soortenLeadValue: [] as any[],
        autosoortenValue: [] as any[],
        merkenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
        comparePeriodData: false as boolean,
        customFromDateCompare: new Date(),
        customToDateCompare: new Date(),
      } as FilterPivotLeadValues,
    },
  },

  data() {
    return {
      initialised: false,
      options: {
        Perioden: [] as DropdownItemModel[],
        Zones: [] as DropdownItemModel[],
        Autobedrijven: [] as AutobedrijfViewModel[],
        Vestigingen: [] as VestigingViewModel[],
        LeadTypes: [] as DropdownItemModel[],
        SoortenLead: [] as DropdownItemModel[],
        Autosoorten: [] as DropdownItemModel[],
        Merken: [] as DropdownItemStringViewModel[],
      } as PivotLeadOptionViewModel,
      handlePreferenceChangedDebounced: null as null | Function,
      autobedrijvenOptionsUpdate: 0,
      vestigingenOptionsUpdate: 0,
    };
  },

  watch: {
    locale(newValue) {
      if (!!newValue) {
        this.updateAutoSoorten();
        this.updateLeadTypes();
        this.updateLeadSoorten();
      }
    },
  },

  computed: {
    locale(): string | null {
      return this.$store.getters.locale;
    },

    zonesOptions(): null | any[] {
      return orderBy(get(this.options, "Zones", []), ["Omschrijving"], ["asc"]);
    },

    zoneGebruiker(): boolean {
      return this.$store.getters.zoneUser;
    },

    autobedrijvenOptions(): any[] {
      let update = this.autobedrijvenOptionsUpdate;
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );
      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      return orderBy(autobedrijven, ["Omschrijving"], ["asc"]);
    },

    vestigingenOptions(): any[] {
      let update = this.vestigingenOptionsUpdate;
      let vestigingen = get(
        this.options,
        "Vestigingen",
        [] as VestigingViewModel[]
      );

      if (!isEmpty(this.autobedrijvenOptions) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          (this.autobedrijvenOptions as any[]).some(
            (a: any) => String(a.Id) === v.AutobedrijfId
          )
        );
      }
      let selectedAutobedrijven = this.selectedOptions.autobedrijvenValue;

      if (!isEmpty(selectedAutobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          (selectedAutobedrijven as any[]).some(
            (a: any) => String(a.Id) === v.AutobedrijfId
          )
        );
      }

      return orderBy(vestigingen, ["Omschrijving"], ["asc"]);
    },

    leadTypesOptions(): null | any[] {
      return orderBy(get(this.options, "LeadTypes", []), ["Id"], ["asc"]);
    },

    soortenLeadOptions(): null | any[] {
      return get(this.options, "SoortenLead", []);
    },

    autosoortenOptions(): null | any[] {
      return orderBy(get(this.options, "Autosoorten", []), ["Id"], ["asc"]);
    },

    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },

    makeOptions(): DropdownItemStringViewModel[] {
      if (this.multipleMakes) {
        return (this.$store.getters.importeurMerken as string[]).map((merk) => {
          return { Id: merk, Omschrijving: merk };
        });
      }
      return [];
    },
  },

  methods: {
    handleDateoptionsChanged(perioden: { Id: number; Omschrijving: string }[]) {
      this.options.Perioden = perioden;
    },

    onDateRangePickerMounted(perioden: { Id: number; Omschrijving: string }[]) {
      this.handleDateoptionsChanged(perioden);
      this.fillFilters();
    },

    fillFilters() {
      axios
        .get("/api/backend/v1/dashboard/leads/grid/options")
        .then((response) => {
          if (!response || !response.data) return;

          const {
            Zones,
            Autobedrijven,
            Vestigingen,
            SoortenLead,
          } = response.data;

          this.options.Zones = Zones;
          this.options.Autobedrijven = Autobedrijven;
          this.options.Vestigingen = Vestigingen;
          const onbekend = {
            Id: 0,
            Omschrijving: `${this.$i18n.t("unknown")}`,
          } as DropdownItemModel;
          this.options.SoortenLead = [onbekend, ...SoortenLead];
          this.options.Autosoorten = this.getAutoSoorten();
          this.options.LeadTypes = this.getLeadTypes();
          this.options.Merken = this.makeOptions;

          this.getSavedPreferences();
        })
        .catch((error) => {});
    },

    getSavedPreferences() {
      axios
        .get("/api/backend/v1/identity/preferences/dashboard/pivot")
        .then((response) => {
          if (!!response && !!response.data && !!response.data.FilterSettings) {
            const filtersettings = response.data
              .FilterSettings as PivotLeadSettingsViewModel;

            this.setFilterSettings(filtersettings);
          }

          this.initialised = true;
          this.$emit("initialised", true);
        })
        .catch((error) => {});
    },

    reduceSelectedOptions(): void {
      let autobedrijven = get(
        this.options,
        "Autobedrijven",
        [] as AutobedrijfViewModel[]
      );
      let zones = this.selectedOptions.zonesValue;

      if (!isEmpty(zones) && !isEmpty(autobedrijven)) {
        autobedrijven = autobedrijven.filter((a) =>
          zones.some((zone: any) => String(zone.Id) === String(a.ZoneId))
        );
      }

      let previous = isEmpty(this.selectedOptions.autobedrijvenValue)
        ? 0
        : this.selectedOptions.autobedrijvenValue.length;
      // update selected autobedrijven als die buiten het huidige filter vallen
      this.selectedOptions.autobedrijvenValue = this.selectedOptions.autobedrijvenValue.filter(
        (a: any) =>
          autobedrijven.some((ab: any) => String(ab.Id) === String(a.Id))
      );
      let current = isEmpty(this.selectedOptions.autobedrijvenValue)
        ? 0
        : this.selectedOptions.autobedrijvenValue.length;

      if (current != previous) this.autobedrijvenOptionsUpdate++;

      ////////////////////////////////////////////////////////////////////////////

      let vestigingen = get(
        this.options,
        "Vestigingen",
        [] as VestigingViewModel[]
      );

      if (!isEmpty(autobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          autobedrijven.some((a: any) => String(a.Id) === v.AutobedrijfId)
        );
      }
      let selectedAutobedrijven = this.selectedOptions.autobedrijvenValue;

      if (!isEmpty(selectedAutobedrijven) && !isEmpty(vestigingen)) {
        vestigingen = vestigingen.filter((v) =>
          (selectedAutobedrijven as any[]).some(
            (a: any) => String(a.Id) === v.AutobedrijfId
          )
        );
      }

      previous = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      // update selected vestigingen als die buiten het huidige filter vallen
      this.selectedOptions.vestigingenValue = this.selectedOptions.vestigingenValue.filter(
        (vValue: any) =>
          vestigingen.some((v: any) => String(v.Id) === String(vValue.Id))
      );

      current = isEmpty(this.selectedOptions.vestigingenValue)
        ? 0
        : this.selectedOptions.vestigingenValue.length;

      if (current != previous) this.vestigingenOptionsUpdate++;
    },

    handlePreferencesChanged: function() {
      if (!this.handlePreferenceChangedDebounced) {
        this.handlePreferenceChangedDebounced = debounce(() => {
          this.reduceSelectedOptions();
          this.persistPreferences();
          this.$emit("preferences-changed", true);
        }, 300);
      }

      this.handlePreferenceChangedDebounced();
    },

    persistPreferences() {
      if (!this.initialised) return;

      const settings = this.getPreferences();

      axios.post(
        "/api/backend/v1/identity/preferences/dashboard/pivot",
        settings,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
    },

    getPreferences(): PivotLeadSettingsViewModel {
      const isCompareDataPeriod = this.selectedOptions.comparePeriodData;

      return {
        CustomStartDate: (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString(),
        CustomEndDate: (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString(),
        ComparePeriodData: this.selectedOptions.comparePeriodData,
        CustomStartDateCompare: isCompareDataPeriod
          ? (moment(this.selectedOptions.customFromDateCompare)).local().startOf("day").toDate().toISOString()
          : null,
        CustomEndDateCompare: isCompareDataPeriod
          ? (moment(this.selectedOptions.customToDateCompare)).local().endOf("day").toDate().toISOString()
          : null,
        SelectedPeriod: get(
          this.selectedOptions,
          "period.Id",
          FixedPeriodType.ThisYear
        ),
        SelectedZones: get(
          this.selectedOptions as Object,
          "zonesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedAutobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedVestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        SelectedLeadTypes: get(
          this.selectedOptions as Object,
          "leadTypesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedLeadsoorten: get(
          this.selectedOptions as Object,
          "soortenLeadValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedAutosoorten: get(
          this.selectedOptions as Object,
          "autosoortenValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        SelectedMerken: get(
          this.selectedOptions as Object,
          "merkenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
      } as PivotLeadSettingsViewModel;
    },

    setPreferences(filterSettings: string): void {
      let filter = JSON.parse(filterSettings) as PivotLeadSettingsViewModel;

      this.setFilterSettings(filter);

      this.handlePreferencesChanged();
    },

    setFilterSettings(filterSettings: PivotLeadSettingsViewModel): void {
      if (!filterSettings || !filterSettings.SelectedZones) return;

      this.selectedOptions.zonesValue = (get(
        this.options,
        "Zones",
        []
      ) as any[]).filter(
        (v) => filterSettings.SelectedZones.indexOf(v.Id) > -1
      );

      this.selectedOptions.autobedrijvenValue = (get(
        this.options,
        "Autobedrijven",
        []
      ) as any[]).filter(
        (m) => filterSettings.SelectedAutobedrijven.indexOf(m.Id) > -1
      );

      this.selectedOptions.vestigingenValue = (get(
        this.options,
        "Vestigingen",
        []
      ) as any[]).filter(
        (a) => filterSettings.SelectedVestigingen.indexOf(a.Id) > -1
      );

      this.selectedOptions.leadTypesValue = (get(
        this.options,
        "LeadTypes",
        []
      ) as any[]).filter(
        (lt) => filterSettings.SelectedLeadTypes.indexOf(lt.Id) > -1
      );

      this.selectedOptions.soortenLeadValue = (get(
        this.options,
        "SoortenLead",
        []
      ) as any[]).filter(
        (a) => filterSettings.SelectedLeadsoorten.indexOf(a.Id) > -1
      );

      this.selectedOptions.autosoortenValue = (get(
        this.options,
        "Autosoorten",
        []
      ) as any[]).filter(
        (a) => filterSettings.SelectedAutosoorten.indexOf(a.Id) > -1
      );

      this.selectedOptions.merkenValue = (get(
        this.options,
        "Merken",
        []
      ) as any[]).filter(
        (a) => filterSettings.SelectedMerken.indexOf(a.Id) > -1
      );

      let period = find(
        get(this.options, "Perioden", []),
        (p) => p.Id === filterSettings.SelectedPeriod
      );

      if (!!period) {
        this.selectedOptions.period = period;
      }

      this.selectedOptions.customFromDate = moment(
        filterSettings.CustomStartDate as string
      ).local().startOf("day").toDate();

      this.selectedOptions.customToDate = moment(
        filterSettings.CustomEndDate as string
      ).local().endOf("day").toDate();

      this.selectedOptions.comparePeriodData = !!filterSettings.ComparePeriodData;

      this.selectedOptions.customFromDateCompare = moment(
        filterSettings.CustomStartDateCompare as string
      ).local().startOf("day").toDate();

      this.selectedOptions.customToDateCompare = moment(
        filterSettings.CustomEndDateCompare as string
      ).local().endOf("day").toDate();
    },

    getAutoSoorten() {
      return [
        { Id: 0, Omschrijving: `${this.$i18n.t("autosoorten.unknown")}` },
        { Id: 1, Omschrijving: `${this.$i18n.t("autosoorten.new")}` },
        { Id: 2, Omschrijving: `${this.$i18n.t("autosoorten.occasion")}` },
      ];
    },

    updateLeadSoorten() {
      this.options.SoortenLead.forEach(
        (soortLead: { Id: any; Omschrijving: string }) => {
          switch (soortLead.Id) {
            case 0:
              soortLead.Omschrijving = `${this.$i18n.t("unknown")}`;
              break;
          }
        }
      );
      this.selectedOptions.soortenLeadValue = this.options.SoortenLead.filter(
        (soortLead: any) =>
          this.selectedOptions.soortenLeadValue.some(
            (selected: any) => String(selected.Id) === String(soortLead.Id)
          )
      );
    },

    updateAutoSoorten() {
      this.options.Autosoorten.forEach(
        (autoSoort: { Id: any; Omschrijving: string }) => {
          switch (autoSoort.Id) {
            case 0:
              autoSoort.Omschrijving = `${this.$i18n.t("autosoorten.unknown")}`;
              break;
            case 1:
              autoSoort.Omschrijving = `${this.$i18n.t("autosoorten.new")}`;
              break;
            case 2:
              autoSoort.Omschrijving = `${this.$i18n.t(
                "autosoorten.occasion"
              )}`;
              break;
          }
        }
      );
      this.selectedOptions.autosoortenValue = this.options.Autosoorten.filter(
        (autosoort: any) =>
          this.selectedOptions.autosoortenValue.some(
            (selected: any) => String(selected.Id) === String(autosoort.Id)
          )
      );
    },

    getLeadTypes() {
      return [
        { Id: 0, Omschrijving: `${this.$i18n.t("leadtypes.unknown")}` },
        { Id: 1, Omschrijving: `${this.$i18n.t("leadtypes.sales")}` },
        { Id: 2, Omschrijving: `${this.$i18n.t("leadtypes.aftersales")}` },
      ];
    },

    updateLeadTypes() {
      this.options.LeadTypes.forEach(
        (leadType: { Id: any; Omschrijving: string }) => {
          switch (leadType.Id) {
            case 0:
              leadType.Omschrijving = `${this.$i18n.t("leadtypes.unknown")}`;
              break;
            case 1:
              leadType.Omschrijving = `${this.$i18n.t("leadtypes.sales")}`;
              break;
            case 2:
              leadType.Omschrijving = `${this.$i18n.t("leadtypes.aftersales")}`;
              break;
          }
        }
      );
    },
  },
});
